if (!customElements.get('lac-lightwrap-selector')) customElements.define('lac-lightwrap-selector', class extends HTMLElement {
  async connectedCallback() {
    if (this.ready) return;
    if (this.dataset.mode === 'product') {
      await customElements.whenDefined('variant-selects');
      if (this.closest('product-info')?.querySelector('pickup-availability')) await customElements.whenDefined('pickup-availability');
      if (!this.isConnected) return;
    }
    this.native = document.getElementById(this.dataset.nativeId);
    if (!this.native) return;
    this.data = JSON.parse(this.querySelector('[data-choice-data]').textContent);
    this.shadeIndex = this.data.options.findIndex(o => o.name === 'Shade');
    this.sizeIndex = this.data.options.findIndex(o => o.name === 'Size');
    if (this.shadeIndex < 0 || this.sizeIndex < 0) return;
    this.ready = true;
    this.abort = new AbortController();
    this.selects = [...this.native.querySelectorAll('select')];
    this.shades = this.data.options[this.shadeIndex].values.map(value => {
      const match = value.name.replace(/^FX - /, '').match(/^(.*) (Light|Mid|Dark|Midnight|Clear)$/);
      return {...value, family: match ? match[1] : value.name, darkness: match ? match[2] : this.data.singleColor};
    });
    this.size = this.querySelector('[data-size-choice]');
    this.data.options[this.sizeIndex].values.forEach(v => this.size.add(new Option(v.name, v.name)));
    const requestedId = new URL(location.href).searchParams.get('variant');
    if (!this.data.selected && requestedId) this.data.selected = this.data.variants.find(v => String(v[0]) === requestedId)?.[1];
    const explicit = this.data.selected && requestedId;
    const selected = explicit && this.shades.find(s => s.name === this.data.selected[this.shadeIndex]);
    this.family = selected ? selected.family : '';
    this.darkness = selected ? selected.darkness : '';
    const sample = this.data.options[this.sizeIndex].values.find(v => /\bsample\b/i.test(v.name));
    this.size.value = explicit ? this.data.selected[this.sizeIndex] : (sample?.name || '');
    this.scope = this.dataset.mode === 'landing' ? this.closest('lac-lightwrap-buy') : this.closest('product-info');
    this.native.hidden = true;
    this.hidden = false;
    this.renderFamilies(); this.renderDarkness();
    this.addEventListener('click', e => {
      const family = e.target.closest('[data-family]');
      const shade = e.target.closest('[data-darkness]');
      if (family && family.dataset.family === this.family) return;
      if (shade && shade.dataset.darkness === this.darkness) return;
      if (family) { this.family = family.dataset.family; this.darkness = ''; this.renderFamilies(); this.renderDarkness(); this.commit(); this.querySelector('[data-family][aria-pressed="true"]')?.focus({preventScroll:true}); }
      if (shade) { this.darkness = shade.dataset.darkness; this.renderDarkness(); this.commit(); this.querySelector('[data-darkness][aria-pressed="true"]')?.focus({preventScroll:true}); }
    }, {signal:this.abort.signal});
    this.size.addEventListener('change', () => this.commit(), {signal:this.abort.signal});
    this.scope.addEventListener('submit', e => {
      if (!this.complete()) { e.preventDefault(); e.stopImmediatePropagation(); this.querySelector('button,select')?.focus(); }
    }, {capture:true,signal:this.abort.signal});
    document.addEventListener('click', e => {
      const action = e.target.closest('[data-choose-finish]');
      if (!action || this.dataset.mode !== 'landing') return;
      e.preventDefault();
      this.family = action.dataset.chooseFinish;
      this.darkness = '';
      this.renderFamilies(); this.renderDarkness(); this.commit();
      this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      this.querySelector('[data-darkness]')?.focus({preventScroll:true});
    }, {signal:this.abort.signal});
    if (this.dataset.mode === 'product') this.native.dataset.updateUrl = 'false';
    this.commit(true);
  }
  makeButton(text, attribute, selected, image) {
    const button = document.createElement('button'); button.type = 'button'; button.dataset[attribute] = text;
    button.setAttribute('aria-pressed', String(selected));
    const media = document.createElement('span'); media.className = 'lw-choice-image'; button.append(media);
    if (image) { const img = document.createElement('img'); img.src = image; img.alt = ''; img.width = 80; img.height = 64; img.loading = 'lazy'; media.append(img); }
    const label = document.createElement('span'); label.className = 'lw-choice-label'; label.textContent = text; button.append(label); return button;
  }
  renderFamilies() {
    const choices = this.querySelector('[data-family-choices]');
    if (choices.children.length) {
      choices.querySelectorAll('[data-family]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.family === this.family)));
      return;
    }
    choices.replaceChildren(...[...new Set(this.shades.map(s=>s.family))].map(f => this.makeButton(f,'family',f===this.family,this.shades.find(s=>s.family===f).image)));
  }
  renderDarkness() {
    this.querySelector('[data-darkness-choices]').replaceChildren(...this.shades.filter(s=>s.family===this.family).map(s=>this.makeButton(s.darkness,'darkness',s.darkness===this.darkness,s.image)));
    const hint = this.querySelector('[data-darkness-hint]'); hint.hidden = !!this.darkness;
    if (this.family) hint.textContent = this.data.chooseDarkness;
  }
  complete() { return !!(this.family && this.darkness && this.size.value); }
  commit(initial = false) {
    const shade = this.shades.find(s=>s.family===this.family && s.darkness===this.darkness);
    const size = this.data.options[this.sizeIndex].values.find(v=>v.name===this.size.value);
    const landing = this.dataset.mode==='landing';
    this.selects[this.shadeIndex].value = shade ? (landing?shade.id:shade.name) : '';
    this.selects[this.sizeIndex].value = size ? (landing?size.id:size.name) : '';
    const ready = this.complete();
    this.scope.classList.toggle('lw-selection-pending', !ready);
    this.querySelector('[data-choice-status]').textContent = ready ? [this.family,this.darkness,this.size.value].join(' · ') : this.dataset.prompt;
    if (landing) {
      this.selects[this.shadeIndex].dispatchEvent(new Event('change',{bubbles:true}));
    } else if (ready) {
      if (initial) return;
      this.selects[this.shadeIndex].dispatchEvent(new Event('change',{bubbles:true}));
      const variant = this.native.currentVariant;
      if (variant) { const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url); }
    } else {
      this.scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(i=>{i.value='';});
      this.scope.querySelectorAll('[name="add"]').forEach(b=>{b.disabled=true;});
      const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState({},'',url);
    }
  }
  disconnectedCallback() { this.abort?.abort(); this.ready=false; }
});
